module.exports = __webpack_public_path__ + "static/5-8987c1802e1d827bfe9d5b159e61adb4.png";